import {
  ITrackingEvent as ITrackingEventLib,
  ITrackingSource as ITrackingSourceLib,
} from '@socialtechnologies/tracking-lib/src/types'

export enum ActionType {
  Click = 'click',
  ClickShow = 'click_show',
  ChatStart = 'chat_start',
  ChatEnd = 'chat_end',
  Show = 'show',
  Change = 'change',
}

export enum EventType {
  Payments = 'payments',
}

export enum PageType {
  DescriptorPage = 'descriptor_page',
}

export enum EventSubtypes {
  DescriptorPage = 'descriptor_page',
  DescriptorForm = 'descriptor_form',
  ChatStarted = 'chat_started',
  ChatEnded = 'chat_ended',
  DescriptorFormInteraction = 'descriptor_form_interaction',
}

export enum SourceObjectValueElementSubtype {
  SendRequestAgain = 'send_request_again',
  SendRequest = 'send_request',
  SupportPopup = 'support_popup',
  DescriptorPage = 'descriptor_page',
  Email = 'email',
  ThankYouScreen = 'thank_you_screen',
  DescriptorForm = 'descriptor_form',
  Faq = 'faq',
  IssueType = 'issue_type',
}

export enum SourceObjectKey {
  ElementSubtype = 'element_subtype',
  Email = 'email',
  FaqSubtype = 'faq_subtype',
  IssueSubtype = 'issue_subtype',
  IdVisit = 'id_visit',
  IdVisitor = 'id_visitor',
  IdVisitorCross = 'id_visitor_cross',
  isTestUser = 'is_test_user',
}

export type SourceObjectContent = ({
  key: SourceObjectKey.ElementSubtype
  value: SourceObjectValueElementSubtype
} | {
  key: SourceObjectKey.Email
  value: string
} | {
  key: SourceObjectKey.FaqSubtype
  value: string
} | {
  key: SourceObjectKey.IssueSubtype
  value: string
} | {
  key: SourceObjectKey.IdVisit
  value: string
} | {
  key: SourceObjectKey.IdVisitor
  value: string
} | {
  key: SourceObjectKey.IdVisitorCross
  value: string
} | {
  key: SourceObjectKey.isTestUser
  value: BooleanValue.TRUE | BooleanValue.FALSE
})[]

export interface ITrackingEvent
  extends ITrackingEventLib<EventType, ActionType> {}

export interface ITrackingSource
  extends ITrackingSourceLib<PageType, TrackingObjectName> {}

export enum TrackingObjectName {
  DescriptorPage = 'descriptor_page',
}

export enum TrackingOriginName {}

export enum BooleanValue {
  TRUE = 'true',
  FALSE = 'false'
}
